export const SELECTABLE_CHUNKS_AFTER_MINUTES = 90;
export const DELETABLE_BEFORE_START_MINUTES = 90;
export const MOBILE_WINDOW_WIDTH_MAX = 1200;
